import React from 'react'

interface MetricCardProps {
  value: string | number
  label: string
  color?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral'
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const MetricCard: React.FC<MetricCardProps> = ({
  value,
  label,
  color = 'neutral',
  size = 'md',
  className = ''
}) => {
  const colorClasses = {
    primary: 'text-blue-400',
    success: 'text-green-400',
    warning: 'text-yellow-400',
    danger: 'text-red-400',
    info: 'text-cyan-400',
    neutral: 'text-white'
  }

  const sizeClasses = {
    sm: 'text-lg sm:text-xl',
    md: 'text-xl sm:text-2xl',
    lg: 'text-2xl sm:text-3xl'
  }

  return (
    <div className={`card text-center ${className}`}>
      <div className={`font-bold ${colorClasses[color]} ${sizeClasses[size]} leading-tight`}>
        {value}
      </div>
      <div className="text-xs sm:text-sm text-gray-400 mt-1">
        {label}
      </div>
    </div>
  )
}

export default MetricCard
